import Vue from 'vue'
import axios from 'axios'
import Vuex from "vuex"
import App2 from './App2.js'
import VueContactForm from './ContactForm.js'

import store from "./datastore/vuexDataStore.js";

//var app = new Vue({
//  store,
//  el: '#app',
//  data: {
//    message: 'master',
//    infobase: null
//  },
//  methods: {
   
//  },
//  mounted() {
//    //console.log(this.$store.state.user.username);
    
//    axios
//      .get('https://api.coindesk.com/v1/bpi/currentprice.json')
//      .then(response => (this.infobase = response));
//  }
  
//})





// WEBPACK FOOTER //
// ./src/main.js